export const SET_BROKEN_LINKS = 'SET_BROKEN_LINKS'



// WEBPACK FOOTER //
// ./src/store/modules/admin/repair-links/types.js